// extracted by mini-css-extract-plugin
export default {"card-ratings":"ProductCardRating_card-ratings__+5CNX","card-rating-star":"ProductCardRating_card-rating-star__N6lyk"};